import React from 'react';
import { AuthContext } from '.';

function useAuth<T extends { role: any }>() {
    const context = React.useContext(AuthContext);
    return { user: context.user as T, setUser: context.setUser };
}

export default useAuth;
